import React from 'react'
import { Cell, Grid, LayoutBand, Skeleton, useContainerWidth } from '@fs/zion-ui'

const HomePageSkeleton = () => {
  // Initiate state variables and hooks
  const atWidth = useContainerWidth()

  return (
    <LayoutBand>
      <Grid data-testid="skeleton-grid">
        <Cell alignY="middle" columns={atWidth({ lg: 12 })}>
          <Skeleton.Image height={250} />
        </Cell>

        <Cell columns={atWidth({ lg: 6 })}>
          <Skeleton.Image height="calc(var(--cell-width, 750px) / 2.5)" />
        </Cell>

        <Cell columns={atWidth({ lg: 6 })}>
          <Skeleton.Image height="calc(var(--cell-width, 750px) / 2.5)" />
        </Cell>

        <Cell columns={atWidth({ lg: 12 })}>
          <Skeleton.Image height={250} />
        </Cell>
      </Grid>
    </LayoutBand>
  )
}

export default HomePageSkeleton
